/**
 * Reads server-rendered props for a widget.
 *
 * The Sitefinity widget view serialises its ViewModel into a
 * <script type="application/json"> block next to the mount point:
 *
 *   <div id="virtual-survey"></div>
 *   <script type="application/json" id="virtual-survey-props">{ ... }</script>
 *
 * Preferred over the hidden-input scraping used by the original Online Booking
 * widget: one parse instead of ~40 getElementById calls, real types (numbers,
 * booleans, arrays, nested objects) instead of strings, and a contract that
 * lives in one place rather than being spread across dozens of markup lines.
 *
 * A <script type="application/json"> block is inert - the browser never
 * executes it - so this carries none of the CSP or injection exposure of
 * assigning to a window global. The server is still responsible for escaping
 * `<` when serialising (see ReactPropsHelper on the C# side).
 */
export const readWidgetProps = (elementId, fallback = {}) => {
  const el = document.getElementById(elementId);

  if (!el) {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn(`[readWidgetProps] no props element "#${elementId}" on the page.`);
    }
    return fallback;
  }

  const raw = el.textContent || el.innerHTML || "";

  try {
    return JSON.parse(raw) || fallback;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`[readWidgetProps] could not parse props from "#${elementId}".`, e);
    return fallback;
  }
};

export default readWidgetProps;
